import { ReactNode } from "react";
interface IconBtnProps {
  icon: ReactNode;
  size: string;
  disabled?: boolean;
  handleClick?: (e: any) => void;
  title?: string;
  isActive?: boolean;
}
function IconBtn({
  icon,
  size,
  handleClick,
  disabled,
  title,
  isActive,
}: IconBtnProps) {
  return (
    <button
      disabled={disabled}
      type="button"
      className={`w-auto flex justify-center items-center gap-3 border-none bg-none disabled:opacity-40 disabled:cursor-default ${isActive && "activeIcon"
        } `}
      onClick={(e) => (handleClick ? handleClick(e) : null)}
      title={title}
    >
      <div className={`h-auto ${size} block`}>{icon}</div>
    </button>
  );
}
export default IconBtn;